import { render, staticRenderFns } from "./PlayerProfileField.vue?vue&type=template&id=0c0e9c55"
import script from "./PlayerProfileField.js?vue&type=script&lang=js&external"
export * from "./PlayerProfileField.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports